
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4068"}},[_c('g',{attrs:{"data-name":"Group 4067","transform":"translate(-1010 -311)"}},[_c('circle',{attrs:{"data-name":"Ellipse 337","cx":"40","cy":"40","r":"40","transform":"translate(1010 311)","fill":"#24f7b8","opacity":".15"}}),_c('g',{attrs:{"data-name":"people"}},[_c('g',{attrs:{"fill":"rgba(0,0,0,0)","stroke":"#01b982","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"d":"M1039.932 342.919a1.011 1.011 0 01.317 0 4.316 4.316 0 10-.317 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1041.652 355.073a9.407 9.407 0 01-6.578-1.2c-2.354-1.569-2.354-4.141 0-5.71a9.466 9.466 0 016.628-1.187"}})]),_c('g',{attrs:{"data-name":"Group","fill":"rgba(0,0,0,0)","stroke":"#01b982","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}},[_c('path',{attrs:{"data-name":"Vector","d":"M1049.965 355.321a1.011 1.011 0 00-.317 0 4.316 4.316 0 11.317 0zM1045.107 360.58c-2.354 1.569-2.354 4.141 0 5.71a9.479 9.479 0 009.717 0c2.354-1.569 2.354-4.141 0-5.71a9.555 9.555 0 00-9.717 0z"}})]),_c('g',{attrs:{"data-name":"dollar-circle","fill":"none","stroke":"#01b982","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Vector","d":"M1059.791 342.053a1.508 1.508 0 001.474 1.546h1.666a1.32 1.32 0 001.287-1.347 1.161 1.161 0 00-.876-1.281l-2.675-.929a1.161 1.161 0 01-.876-1.282 1.32 1.32 0 011.288-1.347h1.666a1.508 1.508 0 011.473 1.547M1062 336.524v7.965"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1068.638 340.507a6.638 6.638 0 11-6.637-6.638 6.638 6.638 0 016.637 6.638z","stroke-width":"2"}})])])])])])
          )
        }
      }
    